(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-snacks-experience"] && !Shopify.designMode) return;
  try {
    
(() => {
  const trailKey = 'ps_all_snacks_passport_v1';
  const searchSection = document.querySelector('.ps-all-snacks--search')?.closest('.shopify-section');
  let searchPositionFrame;
  const positionCatalogSearch = () => {
    const controls = document.querySelector('.cloud-search-page-controls');
    if (!searchSection || !controls || controls.nextElementSibling === searchSection) return;
    controls.insertAdjacentElement('afterend', searchSection);
  };
  const queueSearchPosition = () => {
    window.cancelAnimationFrame(searchPositionFrame);
    searchPositionFrame = window.requestAnimationFrame(positionCatalogSearch);
  };
  const track = (element, action, details = {}) => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;
    const payload = { action, page_type: 'all_snacks', collection_handle: window.location.pathname.split('/collections/')[1]?.split('/')[0] || '', ...details };
    if (typeof window.gtag === 'function') window.gtag('event', 'ps_all_snacks_interaction', payload);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'ps_all_snacks_interaction', ...payload });
    window.dispatchEvent(new CustomEvent('ps:all-snacks-interaction', { detail: payload }));
  };
  const readTrail = () => {
    try { return JSON.parse(window.localStorage.getItem(trailKey) || '[]'); }
    catch (error) { return []; }
  };
  const writeTrail = (items) => {
    try { window.localStorage.setItem(trailKey, JSON.stringify(items.slice(0, 4))); }
    catch (error) { return; }
  };
  const renderTrail = () => {
    const items = readTrail();
    document.querySelectorAll('[data-passport-trail]').forEach((trail) => {
      const list = trail.querySelector('[data-passport-list]');
      if (!list) return;
      list.replaceChildren();
      trail.hidden = !items.length;
      items.forEach((item) => {
        const link = document.createElement('a');
        link.className = 'ps-all-snacks__passport-item';
        link.href = item.url;
        link.dataset.allSnacksAction = 'passport_revisit';
        link.dataset.productHandle = item.handle || '';
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.loading = 'lazy';
          link.appendChild(image);
        }
        const title = document.createElement('span');
        title.textContent = item.title || 'Recent snack';
        link.appendChild(title);
        link.addEventListener('click', () => track(link, 'passport_revisit', { product_handle: item.handle || '' }));
        list.appendChild(link);
      });
    });
  };
  const rememberProduct = (link) => {
    const url = new URL(link.href, window.location.origin);
    const handle = url.pathname.split('/products/')[1]?.split('/')[0] || '';
    if (!handle) return;
    const card = link.closest('li, article, .card, .product-card, [class*="product-card"], [data-product-card]') || link;
    const image = card.querySelector('img') || link.querySelector('img');
    const heading = card.querySelector('h2, h3, .product-card-title, [class*="product-title"], [data-spotlight-title]') || link.querySelector('strong');
    const title = (link.dataset.productTitle || heading?.textContent || image?.alt || link.getAttribute('aria-label') || link.getAttribute('title') || '').trim();
    const item = { url: `${url.pathname}${url.search}`, handle, title: title || 'Recent snack', image: image?.currentSrc || image?.src || '' };
    writeTrail([item, ...readTrail().filter((saved) => saved.handle !== handle)]);
  };
  const rotateSpotlight = (root) => {
    if (root.dataset.manualSpotlight === 'true') return;
    const card = root.querySelector('[data-spotlight-card]');
    const candidates = Array.from(root.querySelectorAll('.ps-all-snacks__spotlight-candidates li'));
    if (!card || !candidates.length) return;
    const day = new Date().toISOString().slice(0, 10);
    const seed = day.split('').reduce((total, character) => total + character.charCodeAt(0), 0);
    const pick = candidates[seed % candidates.length];
    const image = card.querySelector('[data-spotlight-image]');
    const title = card.querySelector('[data-spotlight-title]');
    card.href = pick.dataset.url;
    card.dataset.productHandle = pick.dataset.handle || '';
    card.dataset.productTitle = pick.dataset.title || '';
    if (title) title.textContent = pick.dataset.title || '';
    if (image && pick.dataset.image) {
      image.src = pick.dataset.image;
      image.removeAttribute('srcset');
      image.alt = pick.dataset.title || '';
    }
  };
  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    rotateSpotlight(root);
    root.querySelectorAll('[data-all-snacks-action]').forEach((tracked) => tracked.addEventListener('click', () => {
      track(tracked, tracked.dataset.allSnacksAction, { product_handle: tracked.dataset.productHandle || '', route_name: tracked.dataset.routeName || '' });
    }));
    root.querySelectorAll('[data-passport-clear]').forEach((button) => button.addEventListener('click', () => {
      try { window.localStorage.removeItem(trailKey); } catch (error) { return; }
      renderTrail();
      track(button, 'passport_clear');
    }));
    root.querySelectorAll('[data-spin]').forEach((spin) => spin.addEventListener('click', () => {
      const candidates = Array.from(root.querySelectorAll('.ps-all-snacks__candidates li'));
      const result = root.querySelector('[data-spin-result]');
      const surprise = spin.closest('.ps-all-snacks__surprise');
      if (!candidates.length || !result || !surprise) return;
      spin.disabled = true;
      surprise.classList.add('is-spinning');
      track(spin, 'globe_spin');
      window.setTimeout(() => {
        const pick = candidates[Math.floor(Math.random() * candidates.length)];
        result.innerHTML = pick.innerHTML;
        result.hidden = false;
        surprise.classList.remove('is-spinning');
        spin.disabled = false;
        result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
      }, 1050);
    }));
    renderTrail();
  };
  if (!document.documentElement.dataset.allSnacksTrailReady) {
    document.documentElement.dataset.allSnacksTrailReady = 'true';
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link || !document.querySelector('.ps-all-snacks')) return;
      rememberProduct(link);
    }, true);
  }
  document.querySelectorAll('.ps-all-snacks').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.ps-all-snacks')));
  window.addEventListener('pageshow', renderTrail);
  queueSearchPosition();
  const searchPositionObserver = new MutationObserver(queueSearchPosition);
  searchPositionObserver.observe(document.body, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-brand-hub]').forEach(root => {
 const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
 root.querySelectorAll('a[href="#' + root.querySelector('.ps-brand-hub__directory').id + '"]').forEach(link => {
   link.addEventListener('click', event => {
     event.preventDefault();
     const directory = root.querySelector('.ps-brand-hub__directory');
     directory.scrollIntoView({behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start'});
     root.querySelector('[data-brand-directory-heading]').focus({preventScroll: true});
     history.replaceState(null, '', '#' + directory.id);
   });
 });
 const search = root.querySelector('[data-brand-search]');
 const cards = Array.from(root.querySelectorAll('[data-brand-card]'));
 const buttons = Array.from(root.querySelectorAll('[data-brand-filter]'));
 let category = 'all';
 const filter = () => {
   const term = search.value.trim().toLocaleLowerCase();
   let count = 0;
   cards.forEach(card => {
     const match = card.dataset.brandName.toLocaleLowerCase().includes(term) && (category === 'all' || card.dataset.brandCategory === category);
     card.hidden = !match;
     if (match) count++;
   });
   root.querySelector('[data-brand-count]').textContent = count + ' / ' + cards.length;
   root.querySelector('[data-brand-empty]').hidden = count !== 0;
 };
 search.addEventListener('input',filter);
 buttons.forEach(button=>button.addEventListener('click',()=>{
   category = button.dataset.brandFilter;
   buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
   filter();
 }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discovery-field-guide"] && !Shopify.designMode) return;
  try {
    
const discoveryTrack = (action, element, details = {}) => {
  const section = element.closest('.ps-field-guide, .ps-discovery-collection');
  if (!section) return;
  const privacy = window.Shopify && window.Shopify.customerPrivacy;
  if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
  const payload = {
    action,
    page_type: section.classList.contains('ps-field-guide--best') || section.classList.contains('ps-discovery-collection--best') ? 'best_sellers' : 'new_arrivals',
    section_name: section.classList.contains('ps-discovery-collection') ? 'hero' : section.classList.contains('ps-field-guide--extras') ? 'trails_and_globe' : 'featured',
    collection_handle: window.location.pathname.split('/collections/')[1]?.split('/')[0] || '',
    ...details
  };
  if (typeof window.gtag === 'function') window.gtag('event', 'ps_discovery_interaction', payload);
  else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'ps_discovery_interaction', ...payload });
  document.dispatchEvent(new CustomEvent('pop_snax:discovery', { detail: payload }));
};
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.ps-field-guide [data-quick-toggle]');
  if (toggle) {
    const list = document.getElementById(toggle.getAttribute('aria-controls'));
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    if (list) list.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? 'Show fewer favorites ↑' : `Show ${Math.max(0, (list?.children.length || 2) - 2)} more favorites ↓`;
    discoveryTrack('quick_favorites_toggle', toggle, { expanded });
  }
  const tracked = event.target.closest('[data-discovery-action]');
  if (tracked) discoveryTrack(tracked.dataset.discoveryAction, tracked, { product_handle: tracked.dataset.productHandle || '' });
});
document.addEventListener('toggle', (event) => {
  const trail = event.target.closest('.ps-field-guide__trail');
  if (trail && trail.open) discoveryTrack('trail_open', trail, { trail_name: trail.dataset.trailName || '' });
}, true);
const observeDiscovery = () => {
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting || entry.intersectionRatio < .5) continue;
      const surface = entry.target;
      observer.unobserve(surface);
      discoveryTrack('section_impression', surface, { surface_name: surface.classList.contains('ps-field-guide__surprise') ? 'globe' : surface.classList.contains('ps-field-guide__quick-picks') ? 'quick_favorites' : surface.classList.contains('ps-field-guide__flagship') ? 'flagship' : 'hero' });
    }
  }, { threshold: .5 });
  document.querySelectorAll('.ps-discovery-collection, .ps-field-guide__surprise, .ps-field-guide__quick-picks, .ps-field-guide__flagship').forEach((surface) => {
    if (!surface.dataset.discoveryObserved) {
      surface.dataset.discoveryObserved = 'true';
      observer.observe(surface);
    }
  });
};
const startDiscovery = () => {
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) observeDiscovery();
    });
  } else observeDiscovery();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startDiscovery, { once: true });
else startDiscovery();
document.addEventListener('shopify:section:load', startDiscovery);
document.addEventListener('click', (event) => {
  const button = event.target.closest('.ps-field-guide [data-spin]');
  if (!button) return;
  const section = button.closest('.ps-field-guide');
  const candidates = Array.from(section.querySelectorAll('.ps-field-guide__candidates a'));
  if (!candidates.length) return;
  discoveryTrack('globe_spin', button, { candidate_count: candidates.length });
  let next = Math.floor(Math.random() * candidates.length);
  const previous = Number(button.dataset.previous);
  if (candidates.length > 1 && Number.isInteger(previous) && next === previous) next = (next + 1) % candidates.length;
  button.dataset.previous = String(next);
  const result = section.querySelector('[data-spin-result]');
  const surface = section.querySelector('.ps-field-guide__surprise');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Spinning the globe…';
  surface.classList.remove('is-spinning');
  void surface.offsetWidth;
  surface.classList.add('is-spinning');
  window.setTimeout(() => {
    result.replaceChildren(candidates[next].cloneNode(true));
    result.hidden = false;
    discoveryTrack('globe_reveal', button, { product_handle: candidates[next].dataset.productHandle || '' });
    surface.classList.remove('is-spinning');
    button.disabled = false;
    button.textContent = originalLabel;
  }, reducedMotion ? 0 : 1100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavor-finder-popup"]) return;
  try {
    
  (() => {
    const initPopSnaxQuizPopups = () => {
      document.querySelectorAll('.pop-snax-quiz-popup').forEach((dialog) => {
        if (dialog.dataset.initialized === 'true') return;
        dialog.dataset.initialized = 'true';
        const now = Date.now();
        const day = 86400000;
        const delay = Math.max(0, Number(dialog.dataset.delaySeconds || 7) * 1000);
        const dismissDays = Math.max(1, Number(dialog.dataset.dismissDays || 7));
        const clickDays = Math.max(1, Number(dialog.dataset.clickDays || 30));
        const quizLink = dialog.querySelector('[data-quiz-popup-cta]');
        const normalizePath = (value) => value.replace(/\/+$/, '') || '/';
        const currentPath = normalizePath(window.location.pathname);
        const quizPath = quizLink ? normalizePath(new URL(quizLink.href, window.location.origin).pathname) : '/pages/find-your-snack-match';
        if (currentPath === quizPath || currentPath === '/pages/find-your-snack-match') {
          if (dialog.open) dialog.close();
          dialog.remove();
          return;
        }
        let state = {};
        let completedAt = 0;
        try {
          state = JSON.parse(localStorage.getItem('popSnaxQuizPopupState') || '{}');
          completedAt = Number(localStorage.getItem('popSnaxFlavorFinderCompletedAt') || 0);
        } catch (error) {}
        if (state.dismissedUntil > now || state.clickedUntil > now || completedAt + (180 * day) > now) return;
        if (quizLink) {
          const prefetch = document.createElement('link');
          prefetch.rel = 'prefetch';
          prefetch.href = quizLink.href;
          document.head.appendChild(prefetch);
        }
        const remember = (key, until) => {
          state[key] = until;
          try {
            localStorage.setItem('popSnaxQuizPopupState', JSON.stringify(state));
          } catch (error) {}
        };
        const closePopup = () => {
          remember('dismissedUntil', Date.now() + (dismissDays * day));
          if (dialog.open) dialog.close();
        };
        dialog.querySelectorAll('[data-quiz-popup-close]').forEach((button) => button.addEventListener('click', closePopup));
        quizLink?.addEventListener('click', () => {
          remember('clickedUntil', Date.now() + (clickDays * day));
          dialog.classList.add('is-leaving');
          dialog.setAttribute('aria-busy', 'true');
          quizLink.setAttribute('aria-disabled', 'true');
        });
        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closePopup();
        });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          const inside = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
          if (!inside) closePopup();
        });
        window.setTimeout(() => {
          if (!dialog.isConnected || dialog.open) return;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        }, delay);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPopSnaxQuizPopups, { once: true });
    else initPopSnaxQuizPopups();
    document.addEventListener('shopify:section:load', initPopSnaxQuizPopups);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-country-hub"] && !Shopify.designMode) return;
  try {
    
  const countryHubTrack = (root, interaction, detail = {}) => {
    const payload = {
      event: 'pop_snax_country_hub',
      interaction,
      section_id: root.dataset.countryHub,
      ...detail
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('pop_snax:country_hub', { detail: payload }));
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish('pop_snax:country_hub', {
        interaction,
        section_id: root.dataset.countryHub,
        ...detail
      });
    }
  };

  const countryHubInit = (root) => {
    if (!root || root.dataset.countryHubReady === 'true') return;
    root.dataset.countryHubReady = 'true';

    const carousel = root.querySelector('[data-country-carousel]');
    const cards = carousel ? Array.from(carousel.querySelectorAll('.country-card')) : [];
    const dots = Array.from(root.querySelectorAll('[data-country-dot]'));
    let ticking = false;

    const activateDot = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const nearestCardIndex = () => {
      if (!carousel || cards.length === 0) return 0;
      const left = carousel.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - carousel.offsetLeft - left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    };

    if (carousel && dots.length) {
      carousel.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          activateDot(nearestCardIndex());
          ticking = false;
        });
      }, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const card = cards[index];
          if (!card) return;
          carousel.scrollTo({
            left: card.offsetLeft - carousel.offsetLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
          activateDot(index);
          countryHubTrack(root, 'carousel_dot', { slide: index + 1 });
        });
      });
    }

    root.addEventListener('click', (event) => {
      const target = event.target.closest('[data-country-event]');
      if (!target || target.dataset.countryEvent === 'country_vote') return;
      countryHubTrack(root, target.dataset.countryEvent, {
        country: target.dataset.countryName || undefined,
        product: target.dataset.productName || undefined
      });
    });

    const directory = root.querySelector('.country-directory');
    const expandDirectory = root.querySelector('[data-country-expand]');
    if (directory && expandDirectory) {
      expandDirectory.addEventListener('click', () => {
        directory.classList.add('is-expanded');
        expandDirectory.setAttribute('hidden', '');
      });
    }

    const voteForm = root.querySelector('.country-vote__form');
    if (voteForm) {
      voteForm.addEventListener('submit', () => {
        const selected = voteForm.querySelector('input[name="contact[Requested country]"]:checked');
        countryHubTrack(root, 'country_vote', {
          country: selected ? selected.value : 'not_selected'
        });
      });
    }
  };

  document.querySelectorAll('[data-country-hub]').forEach(countryHubInit);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-country-hub]').forEach(countryHubInit);
  });

  } catch(e) { console.error(e); }
})();
})();
